<h2 mat-dialog-title>{{id? 'Update Coupon Code' : 'Add Coupon Code'}}</h2>
<form [formGroup]="ScanningForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">
        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Code</mat-label>
                <input matInput formControlName="code" placeholder="Enter Coupon Code" autocomplete="off">

                <mat-error *ngIf="ScanningForm.get('code')?.hasError('required')">
                    Coupon code is required
                </mat-error>
            </mat-form-field>

        </div>
        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Discount Type</mat-label>
                <mat-select formControlName="coupon_type">
                    <mat-option value="flat">Flat Amount</mat-option>
                    <mat-option value="percentage">Percentage</mat-option>
                </mat-select>

                <mat-error *ngIf="ScanningForm.get('coupon_type')?.hasError('required')">
                    Discount type is required
                </mat-error>
            </mat-form-field>

        </div>
        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>
                    {{ isPercentage ? 'Discount Percentage' : 'Discount Amount' }}
                </mat-label>

                <input type="number" matInput formControlName="amount" [attr.max]="isPercentage ? 100 : null"
                    [placeholder]="isPercentage
                  ? 'Enter percentage (1–100)'
                  : 'Enter amount (₹)'">

                <mat-error *ngIf="ScanningForm.get('amount')?.hasError('required')">
                    Amount is required
                </mat-error>

                <mat-error *ngIf="ScanningForm.get('amount')?.hasError('max')">
                    Percentage cannot exceed 100
                </mat-error>

                <mat-error *ngIf="ScanningForm.get('amount')?.hasError('min')">
                    Value must be greater than 0
                </mat-error>
            </mat-form-field>

        </div>
        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Allowed Count</mat-label>
                <input type="number" formControlName="allowed_count" matInput placeholder="Enter Allowed Count">
            </mat-form-field>
        </div>
        <div class="column">
            <mat-form-field appearance="outline" *ngIf="id">
                <mat-label>Total Count</mat-label>
                <input type="number" formControlName="total_count" matInput placeholder="Enter Total Count"
                    readonly="true">
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary" [disabled]="ScanningForm.invalid">
            {{id ? 'Update' : 'Add'}}
        </button>
    </mat-dialog-actions>
</form>